import { inject } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { BillingSubscriptionLockoutService } from "../billing/billing-subscription-lockout.service";
import {
  isBillingApiRequest,
  isSubscriptionInactiveHttpError,
} from "../billing/billing-lockout.helper";

export const billingSubscriptionInactiveInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const lockoutService = inject(BillingSubscriptionLockoutService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        isSubscriptionInactiveHttpError(error) &&
        !isBillingApiRequest(req.url)
      ) {
        lockoutService.promptReactivation({
          source: "http",
          apiMessage:
            typeof error.error?.message === "string"
              ? error.error.message
              : typeof error.error?.error === "string"
                ? error.error.error
                : null,
        });
      }

      return throwError(() => error);
    }),
  );
};
